<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.name"
        placeholder="请输入名称"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请输入类别"
        clearable
        size="small"
        v-model="params.processName"
      >
        <el-option
          :label="item.name"
          :value="item.processName"
          v-for="item in processNameList"
          :key="item.processName"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请输入状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请输入类型"
        clearable
        size="small"
        v-model="params.type"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请输入模式"
        clearable
        size="small"
        v-model="params.mode"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in modes"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
      <!-- <el-button type="danger" size="small" icon="el-icon-menu" :disabled="isBatch" plain @click="openBatch">批量操作</el-button> -->
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        v-if="isBatch"
        width="55"
        fixed="left"
        align="center"
      ></el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="类型名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enText"
        label="英文文本"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.enText || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="processName"
        label="提示词类别"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.processName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">开启</el-tag>
          <el-tag v-else-if="scope.row.status == 2">关闭</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="mode"
        label="提示词模式"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.mode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="level"
        label="提示词级别"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.level }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="subAiPrompt" label="子目录" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.subAiPrompt || '-' }}</span>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="updateAct"
        label="修改账号"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updateAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0" v-if="isBatch">
      <el-button @click="giveUpBatch" type="danger" size="mini"
        >取消批量操作</el-button
      >
      <el-button @click="openBatchDelete" type="primary" size="mini"
        >批量删除</el-button
      >
    </div>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="530px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="140px" :rules="rules" ref="form">
        <el-form-item label="提示词名称" prop="name" style="width: 400px">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          label="提示词类别"
          prop="processName"
          style="width: 400px"
        >
          <el-select v-model="form.processName">
            <el-option
              :label="item.name"
              :value="item.processName"
              v-for="item in processNameList"
              :key="item.processName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示词类型" prop="type" style="width: 400px">
          <el-select v-model="form.type">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中文文本" prop="zhText" style="width: 400px">
          <el-input v-model="form.zhText"></el-input>
        </el-form-item>
        <el-form-item label="英文文本" prop="enText" style="width: 400px">
          <el-input v-model="form.enText"></el-input>
        </el-form-item>
        <el-form-item label="提示词模式" prop="mode" style="width: 400px">
          <el-select v-model="form.mode">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in modes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示词状态" prop="status" style="width: 400px">
          <el-select v-model="form.status">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示词排序" prop="sort" style="width: 400px">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        name: undefined, // 名称
        processName: undefined, // 类别
        status: undefined, // 状态
        type: undefined, // 类型
        mode: undefined, // 模式
      },

      rules: {
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        processName: [
          { required: true, message: "请输入类别", trigger: "blur" },
        ],
        type: [{ required: true, message: "请输入类型", trigger: "blur" }],
        zhText: [
          { required: true, message: "请输入中文文本", trigger: "blur" },
        ],
        enText: [
          { required: true, message: "请输入英文文本", trigger: "blur" },
        ],
      },
      modes: [
        {
          label: "普通模式",
          value: 1,
        },
        {
          label: "成人模式",
          value: 2,
        },
      ],
      statuses: [
        {
          label: "开启",
          value: 1,
        },
        {
          label: "关闭",
          value: 2,
        },
      ],
      types: [
        {
          label: "绘画风格",
          value: 1,
        },
        {
          label: "头部动作",
          value: 2,
        },
        {
          label: "眼部动作",
          value: 3,
        },
        {
          label: "嘴部动作",
          value: 4,
        },
        {
          label: "手部动作",
          value: 5,
        },
        {
          label: "腿部动作",
          value: 6,
        },
        {
          label: "成人模式",
          value: 7,
        },
        {
          label: "头发装饰",
          value: 8,
        },
        {
          label: "刘海相关",
          value: 9,
        },
        {
          label: "辫子相关",
          value: 10,
        },
        {
          label: "发型相关",
          value: 11,
        },
        {
          label: "头发颜色",
          value: 12,
        },
        {
          label: "头发长度",
          value: 13,
        },
        {
          label: "腿部相关",
          value: 14,
        },
        {
          label: "袜子相关",
          value: 15,
        },
        {
          label: "鞋子相关",
          value: 16,
        },
        {
          label: "眼睛相关",
          value: 17,
        },
        {
          label: "耳朵相关",
          value: 18,
        },
        {
          label: "情绪相关",
          value: 19,
        },
        {
          label: "时令气候",
          value: 20,
        },
        {
          label: "地理位置",
          value: 21,
        },
        {
          label: "服饰类型",
          value: 22,
        },
        {
          label: "泳装相关",
          value: 23,
        },
        {
          label: "胸部大小",
          value: 24,
        },
        {
          label: "人物数量",
          value: 25,
        },
        {
          label: "人物风格",
          value: 26,
        },
        {
          label: "性格外表",
          value: 27,
        },
        {
          label: "画质优化",
          value: 28,
        },
        {
          label: "景观镜头",
          value: 29,
        },
      ], //类型列表
      processNameList: [],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: "", // 名称
        type: "", // 类型
        processName: undefined, // AI提示词类名称
        zhText: undefined, // 中文文本
        enText: undefined, // 英文文本
        mode: 1, // 模式 1 普通模式 2 成人模式
        status: 1, // 状态，1 开启 2关闭 默认为1
        sort: 0, // 排序 默认0
      },
      oldName: "",
      oldType: "",
      oldProcessName: "",
      isBatch: false,
      dataIds: [],
      batchUpdateDialog: false,
      batchStatus: 0,
    };
  },
  created() {
    this.getList();
    this.getOneLevelPromptList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getPromptList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          if (this.isBatch) {
            this.restoreCheckedState();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getOneLevelPromptList() {
      API.getOneLevelPromptList().then((res) => {
        if (res.code === 200 && res.data) {
          this.processNameList = res.data;
        }
      });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.icon = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.type = param.type;
        this.form.processName = param.processName;
        this.form.zhText = param.zhText;
        this.form.enText = param.enText;
        this.form.mode = param.mode;
        this.form.status = param.status;
        this.form.sort = param.sort;
        this.oldName = param.name;
        this.oldProcessName = param.processName;
        this.oldType = param.type;
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.type = Number(this.form.type);
          API.addPrompt(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.type = Number(this.form.type);
          let req = {
            id: this.form.id,
            name: this.oldName == this.form.name ? undefined : this.form.name, // 名称
            type: this.oldType == this.form.type ? undefined : this.form.type, // 类型
            processName: this.oldProcessName == this.form.processName ? undefined : this.form.processName, // AI提示词类名称
            zhText: this.form.zhText, // 中文文本
            enText: this.form.enText, // 英文文本
            mode:  this.form.mode == '普通模式' ? 1 : 2, // 模式 1 普通模式 2 成人模式
            status: this.form.status, // 状态，1 开启 2关闭 默认为1
            sort: this.form.sort, // 排序 默认0
          };
          API.updatePrompt(req).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPrompt(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = "";
      this.form.type = undefined;
      this.form.processName = undefined;
      this.form.zhText = undefined;
      this.form.enText = undefined;
      this.form.mode = 1;
      this.form.status = 1;
      this.form.sort = 0;
      this.isBatch = false;
      this.dataIds = [];
      this.batchStatus = 0;
      this.batchUpdateDialog = false;
      this.$refs.multipleTable.clearSelection();
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // *******************批量操作*********************
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.dataIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    // 批量操作窗口
    openBatch() {
      this.isBatch = true;
    },
    // 取消批量操作
    giveUpBatch() {
      this.isBatch = false;
      this.dataIds = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 打开批量删除窗口
    openBatchDelete() {
      if (this.dataIds.length === 0)
        return this.$message.error("请至少选择一条数据");
      const ids = this.dataIds.map((item) => item.id);
      // 确认删除提示
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const req = {
            id: ids,
          };
          API.delPrompt(req).then((res) => {
            if (res.code === 200) {
              this.getList();
              this.handleClose();
              this.$message.success("批量删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message.success("取消成功");
        });
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.dataIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.dataIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      const tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.dataIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.dataIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.dataIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.dataIds = this.dataIds.concat(objArr);
      const tempDatas = new Set(this.dataIds);
      this.dataIds = Array.from(tempDatas);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
